"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "track-icon" };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_planetary_track_rewards = (0, vue_1.resolveComponent)("planetary-track-rewards");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("tr", null, [
        (0, vue_1.createElementVNode)("td", null, [
            (0, vue_1.createElementVNode)("div", _hoisted_1, (0, vue_1.toDisplayString)(_ctx.icon), 1)
        ]),
        ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.range, (idx) => {
            return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("td", {
                key: idx,
                class: (0, vue_1.normalizeClass)(_ctx.getClass(idx))
            }, [
                (idx <= _ctx.rewards.spaces.length && _ctx.rewards.spaces[idx] !== undefined)
                    ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_planetary_track_rewards, {
                        key: 0,
                        type: _ctx.type,
                        rewards: _ctx.rewards.spaces[idx],
                        gameOptions: _ctx.gameOptions
                    }, null, 8, ["type", "rewards", "gameOptions"]))
                    : (0, vue_1.createCommentVNode)("", true)
            ], 2));
        }), 128))
    ]));
}
